import React from "react";

function FeaturedList() {
  return (
    <div className="mt-10 px-4 sm:px-6 lg:px-8 text-center">
      <h1 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
        Featured Articles
      </h1>

      <section className="mt-12 space-y-8 text-left text-gray-300">
        {/* Scale Article with image links */}
        <div>
          <h3 className="text-xl font-medium text-white">
            Scale Article
          </h3>
          <p>
         Authored a PI Spotlight article featuring Dr. David Crandall, Director of the Luddy Artificial Intelligence Center at Indiana University, and Ms. Sarah Carroll, the center's Program and Finance Manager, highlighting efforts in advancing trusted AI. 
            <br />
            <p className="text-teal-400 ">
              Click the on the images below to view the full pages.
            </p>
          </p>
          {/* Image links to full pages */}
          <div className="mt-4 flex justify-start space-x-6">
            <a
              href="/assets/Featured/PageOne.png"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-75"
            >
              <img
                src="/assets/Featured/PageOne.png"
                alt="Scale Article Page One"
                className="inline-block w-32 h-auto rounded-lg shadow-lg"
              />
            </a>
            <a
              href="/assets/Featured/PageTwo.png"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-75"
            >
              <img
                src="/assets/Featured/PageTwo.png"
                alt="Scale Article Page Two"
                className="inline-block w-32 h-auto rounded-lg shadow-lg"
              />
            </a>
          </div>
        </div>

        <div>
          <h3 className="text-xl font-medium text-white">
            NASA HUNCH, Design and Prototype: Insect Nanolab
          </h3>
          <p>
            One of 318 students chosen to present an insect nanolab prototype at NASA’s Final Design Review in Houston.
            <br />
            <a
              href="https://www.hunchdesign.com/uploads/2/2/0/9/22093000/insect_nanolab_finalist_s.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-400 hover:underline"
            >
              hunchdesign.com
            </a>
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium text-white">
            Jewish Fraternity Reinvents, Preserves 100-Year Legacy in New Chapter
          </h3>
          <p>
            Interviewed and quoted in the Jewish Exponent for my role in reestablishing Sigma Alpha Rho.
            <br />
            <a
              href="https://www.jewishexponent.com/jewish-fraternity-reinvents-preserves-100-year-legacy-in-new-chapter/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-400 hover:underline"
            >
              Jewish Exponent
            </a>
          </p>
        </div>

        <div>
          <h3 className="text-xl font-medium text-white">
            Widener Honors Winners of High School Leadership Awards
          </h3>
          <p>
            Coverage by The Bucks County Herald on the 12th annual Widener University High School Leadership Awards, in partnership with NBC10 and Telemundo62.
            <br />
            <a
              href="https://issuu.com/widener/docs/hsla_2023_program"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-400 hover:underline"
            >
              The Bucks County Herald
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}

export default FeaturedList;
